import { ClickInputInstruction } from '../ClickInputInstruction'

export class SaveInAddressBookInstruction extends ClickInputInstruction {
  constructor ({ waitForNoLoaders, label, click }) {
    super({
      name: 'SaveInAddressBook',
      waitForNoLoaders,
      label,
      click: click === undefined ? false : click

    })
  }
}
